"use strict";

exports.__esModule = true;
exports.AlertsController = void 0;
var _react = require("react");
var _vimanaTypes = require("@vimana/vimana-types");
var _API = require("../../API");
var _User = require("../../User");
var _Auth = require("../../Auth");
var _constants = require("../../Logbook/constants");
var _Utils = require("../../../Utils");
var _dec, _dec2, _dec3, _class, _AlertsController;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var formatAlertResponse = function formatAlertResponse(alert, commentResponse, users) {
  alert.watchers = alert.watchers.map(function (watcher) {
    if (watcher.type === "EMAIL") return watcher.value;
    var user = users.getUser(watcher.value);
    return user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER;
  });
  return Object.assign({}, alert, {
    comments: commentResponse
  });
};
var AlertsController = exports.AlertsController = (_dec = _API.RestAPIContext.withContext, _dec2 = _User.UserListContext.withContext, _dec3 = _Auth.AuthContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_AlertsController = /*#__PURE__*/function (_Component) {
  function AlertsController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      loading: false,
      getAlertDetails: function () {
        var _getAlertDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alertId) {
          var users, _yield$Promise$all, alert, commentResponse;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                users = _this.props.users;
                _context.n = 1;
                return Promise.all([_this.props.api.get("/api/v3/alerts/alert/" + alertId), _this.props.api.get("api/v3/alerts/alert/" + alertId + "/comment")]);
              case 1:
                _yield$Promise$all = _context.v;
                alert = _yield$Promise$all[0];
                commentResponse = _yield$Promise$all[1];
                return _context.a(2, formatAlertResponse(alert, commentResponse, users));
            }
          }, _callee);
        }));
        function getAlertDetails(_x) {
          return _getAlertDetails.apply(this, arguments);
        }
        return getAlertDetails;
      }(),
      updateAlertDetails: function () {
        var _updateAlertDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(alertId, updateObject) {
          var _this$props, username, users, user, userId, updateTicketQuery, _yield$Promise$all2, alert, commentResponse;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this$props = _this.props, username = _this$props.auth.username, users = _this$props.users;
                user = users.getUserByName(username);
                userId = user && user.id;
                if (!(userId && updateObject)) {
                  _context2.n = 2;
                  break;
                }
                updateTicketQuery = Object.assign({}, updateObject, {
                  updatorId: userId
                });
                _context2.n = 1;
                return Promise.all([_this.props.api.put("/api/v3/alerts/alert/" + alertId, updateTicketQuery), _this.props.api.get("api/v3/alerts/alert/" + alertId + "/comment")]);
              case 1:
                _yield$Promise$all2 = _context2.v;
                alert = _yield$Promise$all2[0];
                commentResponse = _yield$Promise$all2[1];
                return _context2.a(2, formatAlertResponse(alert, commentResponse, users));
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        function updateAlertDetails(_x2, _x3) {
          return _updateAlertDetails.apply(this, arguments);
        }
        return updateAlertDetails;
      }(),
      createAlertComment: function () {
        var _createAlertComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(alertId, comment) {
          var _this$props2, username, users, user, commentQuery, _yield$Promise$all3, alert, commentResponse;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this$props2 = _this.props, username = _this$props2.auth.username, users = _this$props2.users;
                user = users.getUserByName(username);
                commentQuery = {
                  body: comment,
                  author: {
                    type: "USER",
                    value: user ? (0, _Utils.formatUserName)(user) : _constants.INTERNAL_USER
                  }
                };
                _context3.n = 1;
                return _this.props.api.post("api/v3/alerts/alert/" + alertId + "/comment", commentQuery);
              case 1:
                _context3.n = 2;
                return Promise.all([_this.props.api.get("/api/v3/alerts/alert/" + alertId), _this.props.api.get("api/v3/alerts/alert/" + alertId + "/comment")]);
              case 2:
                _yield$Promise$all3 = _context3.v;
                alert = _yield$Promise$all3[0];
                commentResponse = _yield$Promise$all3[1];
                return _context3.a(2, formatAlertResponse(alert, commentResponse, users));
            }
          }, _callee3);
        }));
        function createAlertComment(_x4, _x5) {
          return _createAlertComment.apply(this, arguments);
        }
        return createAlertComment;
      }(),
      patchAlert: function () {
        var _patchAlert = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(alertId, alert) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return _this.props.api.patch("/api/v3/alerts/alert/" + alertId, alert);
              case 1:
                return _context4.a(2, _context4.v);
            }
          }, _callee4);
        }));
        function patchAlert(_x6, _x7) {
          return _patchAlert.apply(this, arguments);
        }
        return patchAlert;
      }()
    };
    return _this;
  }
  _inheritsLoose(AlertsController, _Component);
  var _proto = AlertsController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return AlertsController;
}(_react.Component), _AlertsController.defaultProps = {
  api: undefined,
  users: undefined,
  devices: undefined
}, _AlertsController)) || _class) || _class) || _class);
AlertsController.displayName = "AlertsController";